import { StaticImageData } from "next/image";

import { formatImageUrl } from "@/lib/utils";
import { DEFAULT_PLACEHOLDER } from "@/utils/constants";
import OptimizedImage from "../common/images/OptimizedImage";

interface CarCardImageProps {
  mediaUrl?: string | StaticImageData | null;
  blurPlaceholder: string;
  makeModel: string;
  index: number;
  priority?: boolean;
  loading?: "eager" | "lazy";
}

export function CarCardImage({
  mediaUrl,
  makeModel,
  blurPlaceholder,
  index,
  priority = index === 0,
  loading = priority ? "eager" : "lazy",
}: CarCardImageProps) {
  const imageUrl = typeof mediaUrl === "string" ? `${formatImageUrl(mediaUrl)}` : mediaUrl;

  return (
    <div className="relative h-60 overflow-hidden rounded-3xl">
      <OptimizedImage
        // fill
        fetchPriority={priority ? "high" : "low"}
        priority={priority}
        quality={50}
        // Widest card per breakpoint across all CarsCard layouts (90vw container, minus gaps and p-1).
        sizes="(max-width: 767px) calc(90vw - 8px), (max-width: 1279px) calc(45vw - 16px), calc(30vw - 16px)"
        maxWidth={750}
        width={400}
        height={0}
        imageLayout="custom"
        src={imageUrl ?? DEFAULT_PLACEHOLDER}
        alt={`${makeModel} image`}
        className={`rounded-3xl object-contain object-bottom transition-transform duration-700`}
        loading={loading}
        placeholder="blur"
        blurDataURL={blurPlaceholder}
      />
    </div>
  );
}
